import { useEffect, useRef, useState } from 'react';

const AdUnit = ({ slot, format = 'auto', layout = '', className = '' }) => {
  return null;
  const adRef = useRef(null);
  const isAdLoaded = useRef(false);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!isClient) return;
    if (process.env.NODE_ENV === 'development') return;
    if (isAdLoaded.current) return;

    const timer = setTimeout(() => {
      try {
        const ins = adRef.current?.querySelector('.adsbygoogle');
        if (ins && !ins.getAttribute('data-ad-status')) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          isAdLoaded.current = true;
        }
      } catch (e) {
        // 忽略錯誤
        // console.error('AdSense error:', e);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [isClient]);

  if (!isClient) {
    return <div className={`min-h-[100px] w-full ${className}`} />;
  }

  return (
    <div
      ref={adRef}
      className={`ad-container min-h-[100px] w-full ${className}`}
    >
      {process.env.NODE_ENV === 'development' ? (
        <div className="flex h-[100px] items-center justify-center bg-gray-200 text-gray-500">
          {slot} 廣告區塊（開發模式）
        </div>
      ) : (
        <ins
          className="adsbygoogle"
          style={{ display: 'block', textAlign: 'center' }}
          data-ad-client="ca-pub-7575047962123456"
          data-ad-slot={slot}
          data-ad-format={format}
          {...(layout && { 'data-ad-layout': layout })}
          data-full-width-responsive="true"
        />
      )}
    </div>
  );
};

export default AdUnit;
